import React, { useEffect, useMemo, useState } from 'react';
import { useCurrentRoute, Link } from 'react-navi';
import ReactGA from 'react-ga';
import { getBirthday, Entry, NavBar, Prize } from '@contest-web/components/src/components';
import {
  MystaIconButton,
  InstagramIconButton,
  TwitterIconButton,
  ShowroomIconButton,
} from '@contest-web/components/src/elements';
import { Helmet } from 'react-navi-helmet-async';
import { EntriesRepository } from '../repositories/entries';
import { FavoriteButton } from '../../../components/src/elements/FavoriteButton';

function ProfileApp(props: { entry: Entry; profile: any; prize: Prize | undefined }) {
  const { entry, profile, prize } = props;
  const voteUrl = 'https://www.rizeclinic.com/missmrcampus2019/frecam-vote';
  let [event, setEvent] = useState(null);
  let route = useCurrentRoute();

  const title = `${entry.name} | ${process.env.REACT_APP_WEBSITE_NAME}`;
  const url = `${process.env.REACT_APP_URL}/profile/${entry.id}`;
  const share = (navigator as any).share;

  if (entry.mysta) {
    useEffect(() => {
      const fetch = async () => {
        setEvent(await EntriesRepository.getEvent(entry.mysta!));
      };
      fetch();
    }, [entry.mysta]);
  }
  return (
    <div>
      <Helmet>
        <meta content={title} property="og:title" />
        <meta content={`${process.env.REACT_APP_URL}/images/entries/${entry.id}.jpg`} property="og:image" />
        <meta content={url} property="og:url" />
        <body />
      </Helmet>
      <div className="hero">
        <div className="hero-head">
          <NavBar
            logoImageSrc="/images/logo_black.svg"
            entryUrl={`${process.env.REACT_APP_ENTRY_FORM_URL}${route.url.search}`}
          />
        </div>
      </div>
      <section className="section is-padding-bottom-0">
        <div className="container">
          <nav className="breadcrumb is-right is-small-mobile" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link className="has-text-primary" href="/top">
                  TOP
                </Link>
              </li>
              <li>
                {prize === Prize.final && (
                  <Link className="has-text-primary" href="/final">
                    ファイナル
                  </Link>
                )}
                {prize === Prize.semifinal && (
                  <Link className="has-text-primary" href="/semifinal">
                    セミファイナル
                  </Link>
                )}
                {prize === Prize.third && (
                  <Link className="has-text-primary" href="/third">
                    4次審査
                  </Link>
                )}
                {prize === Prize.second && (
                  <Link className="has-text-primary" href="/second">
                    2次審査通過者一覧
                  </Link>
                )}
              </li>
              <li className="is-active">
                <Link href={`/profile/${entry.id}`} aria-current="page">
                  {entry.name}
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </section>
      <section className="section">
        <div className="container is-slim">
          <div className="columns is-variable is-6">
            <div className="column">
              <figure className="image is-square">
                <img src={`/images/entries/${entry.id}.jpg`} />
                <FavoriteButton entryId={entry.id} />
              </figure>
            </div>
            <div className="column is-size-6-tablet is-size-5-desktop">
              <div className="columns is-3 is-variable is-flex-direction-column">
                <div className="column">
                  {entry.final && (
                    <p className="tags has-addons is-size-6 has-text-grey-light is-margin-bottom-1">
                      <span className="tag is-gold">ファイナル</span>
                      <span className="tag is-primary is-light">{entry.final}</span>
                    </p>
                  )}{' '}
                  {entry.semifinal && (
                    <p className="tags has-addons is-size-6 has-text-grey-light is-margin-bottom-1">
                      <span className="tag">セミファイナル</span>
                      <span className="tag  is-primary is-light">{entry.semifinal}</span>
                    </p>
                  )}
                  <p className="is-size-6 has-text-grey-light">
                    {entry.college} {profile.grade}
                  </p>
                  <div className="columns is-align-center is-mobile is-margin-bottom-0-5">
                    <div className="column is-narrow">
                      <h1 className="is-size-3 has-text-weight-light has-text-grey">{entry.name}</h1>
                      <h2 className="is-size-6 has-text-grey-light has-text-uppercase">
                        {profile.roman_first_name} {profile.roman_last_name}
                      </h2>
                    </div>
                    <div className="column">
                      <p className="buttons">
                        {entry.twitter && <TwitterIconButton href={`https://twitter.com/${entry.twitter}`} />}
                        {entry.instagram && <InstagramIconButton href={`https://instagram.com/${entry.instagram}`} />}
                        {entry.mysta && (
                          <MystaIconButton
                            target="_blank"
                            href={`https://appweb.mysta.tv/web/share/profile?id=${entry.mysta}`}
                          />
                        )}
                        {entry.showroom && (
                          <ShowroomIconButton
                            target="_blank"
                            href={`https://www.showroom-live.com/room/profile?room_id=${entry.showroom}`}
                          />
                        )}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="column">
                  {profile.birthday && (
                    <div className="columns is-mobile is-margin-bottom-0-5">
                      <div className="column is-narrow">
                        <p className="has-text-primary">生年月日</p>
                      </div>
                      <div className="column">
                        <p>{getBirthday(profile.birthday)}</p>
                      </div>
                    </div>
                  )}
                  {profile.hometown && (
                    <div className="columns is-mobile is-margin-bottom-0-5">
                      <div className="column is-narrow">
                        <p className="has-text-primary">出身地　</p>
                      </div>
                      <div className="column">
                        <p>{profile.hometown}</p>
                      </div>
                    </div>
                  )}
                  {profile.hobby && (
                    <div className="columns is-mobile is-margin-bottom-0-5">
                      <div className="column is-narrow">
                        <p className="has-text-primary">趣味　　</p>
                      </div>
                      <div className="column">
                        <p>{profile.hobby}</p>
                      </div>
                    </div>
                  )}
                  {profile.skill && (
                    <div className="columns is-mobile is-margin-bottom-0-5">
                      <div className="column is-narrow">
                        <p className="has-text-primary">特技　　</p>
                      </div>
                      <div className="column">
                        <p>{profile.skill}</p>
                      </div>
                    </div>
                  )}
                </div>
                {prize === Prize.final && (
                  <div className="column">
                    <a className="button is-primary is-medium is-fullwidth has-text-weight-bold" href={voteUrl}>
                      WEB投票サイト
                    </a>
                    <p className="is-margin-top-1 is-size-7 has-text-grey has-text-centered">※ 投票期間外です</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section is-padding-top-0-5">
        <div className="container is-slim">
          <div className="columns is-tablet is-margin-bottom-0-5">
            {profile.dream && (
              <div className="column">
                <p className="subtitle is-margin-bottom-0-5-touch is-size-6-touch is-size-5-desktop has-text-primary">
                  将来の夢
                </p>
                <p>{profile.dream}</p>
              </div>
            )}
            {profile.challenge && (
              <div className="column">
                <p className="subtitle is-margin-bottom-0-5-touch is-size-6-touch is-size-5-desktop has-text-primary">
                  学生生活で挑戦したいこと
                </p>
                <p>{profile.challenge}</p>
              </div>
            )}
            {profile.ambition && (
              <div className="column">
                <p className="subtitle is-margin-bottom-0-5-touch is-size-6-touch is-size-5-desktop has-text-primary">
                  コンテストへの意気込み
                </p>
                <p>{profile.ambition}</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default ProfileApp;
